<template>
    <div id="services-business-crypto">
        <div class="phone-illustration-wrapper">
            <div class="illustration-container">
                <img class="phone-web-illustration" src="/images/elements/home/web/business-crypto.png"
                    alt="business-crypto" />
            </div>
        </div>
        <div class="content-container">
            <div class="content-inner">
                <div class="container">
                    <div class="content-section">
                        <div class="title headline-l" v-html="$t('ourServicesScreen.businessCrypto.title')">
                        </div>
                        <div class="phone-illustration-mobile-wrapper">
                            <img class="phone-mobile-illustration"
                                src="/images/elements/home/web/business-crypto-mobile.png"
                                alt="business-crypto-mobile" />
                        </div>
                        <div class="bottom-section">
                            <div class="features-grid">
                                <div v-for="(feature, index) in features" :key="index" class="feature-box">
                                    <img :src="feature.icon" alt="" class="feature-icon" />
                                    <span class="feature-title">{{ feature.title }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ServicesBusinessCrypto',
    props: {},
    components: {},
    data: () => ({}),
    created() { },
    computed: {
        features() {
            return [
                {
                    icon: '/images/icons/asset-order-green.svg',
                    title: this.$t('ourServicesScreen.businessCrypto.features.tokenStructure'),
                },
                {
                    icon: '/images/icons/license-green.svg',
                    title: this.$t('ourServicesScreen.businessCrypto.features.compliance'),
                },
                {
                    icon: '/images/icons/legal-process-green.svg',
                    title: this.$t('ourServicesScreen.businessCrypto.features.legalFrameworks'),
                },
                {
                    icon: '/images/icons/transfers-green.svg',
                    title: this.$t('ourServicesScreen.businessCrypto.features.kyc'),
                },
                {
                    icon: '/images/icons/shop-green.svg',
                    title: this.$t('ourServicesScreen.businessCrypto.features.marketEntry'),
                },
                {
                    icon: '/images/icons/security-green.svg',
                    title: this.$t('ourServicesScreen.businessCrypto.features.secureIssuance'),
                },
                {
                    icon: '/images/icons/circle-check-green.svg',
                    title: this.$t('ourServicesScreen.businessCrypto.features.strategicAdvisory'),
                },
                {
                    icon: '/images/icons/wallet-green.svg',
                    title: this.$t('ourServicesScreen.businessCrypto.features.walletServices'),
                },
            ];
        },
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
#services-business-crypto {
    height: 582px;
    width: 100%;
    background: #040428;
    border-bottom: 1px solid #6464FF;

    @media (max-width: $breakpoint-md) {
        height: fit-content;
    }

    .phone-illustration-mobile-wrapper {
        justify-content: center;
        display: flex;
        margin-bottom: $margin-s;
        height: 234px;
        width: 100%;

        @media (min-width: $breakpoint-md) {
            display: none;
        }

        .phone-mobile-illustration {
            height: 234px;
            width: 100%;
            object-fit: cover;
        }
    }

    .phone-illustration-wrapper {
        height: 582px;
        width: 100%;
        position: absolute;
        align-items: center;
        display: flex;

        @media (max-width: $breakpoint-md) {
            display: none;
        }

        .phone-web-illustration {
            position: absolute;
            z-index: 1;
            right: 0;
            height: 582px;
            width: 450px;
            object-fit: cover;
            @media (max-width: $breakpoint-lg) {
                width: 350px;
            }


        }
    }

    .illustration-container {
        height: 582px;
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
    }

    .container {
        @media (min-width: $breakpoint-lg) {
            max-width: 1196px;
        }

        @media (max-width: $breakpoint-xs) {
            padding-left: 0px;
            padding-right: 0px;
        }
    }

    .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;

        .content-inner {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            z-index: 1;

            .content-section {
                .title {
                    margin-bottom: 60px;
                    letter-spacing: 0em;
                    text-align: left;
                    text-transform: uppercase;
                    color: $white;

                    @media (max-width: $breakpoint-lg) {
                        max-width: calc(100vw - (100vw - 960px) - 350px - 20px);
                    }

                    @media (max-width: $breakpoint-md) {
                        text-align: center;
                        max-width: unset;
                        margin-bottom: 30px;
                    }
                }

                .bottom-section {
                    @media (max-width: $breakpoint-xs) {
                        padding-left: 15px;
                        padding-right: 15px;
                    }
                }

                .features-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 30px;
                    max-width: calc(100vw - (100vw - 1196px) - 450px - 20px);

                    @media (max-width: $breakpoint-lg) {
                        max-width: calc(100vw - (100vw - 960px) - 350px - 20px);
                        gap: 16px;
                    }

                    @media (max-width: $breakpoint-md) {
                        max-width: unset;
                    }

                    .feature-box {
                        background: #4656FF;
                        display: flex;
                        align-items: center;
                        gap: 12px;
                        padding: 14px 14px;

                        @media (max-width: $breakpoint-sm) {
                            flex-direction: column;
                            padding: 8px 12px 12px 12px;
                            justify-content: center;
                            gap: 8px;
                        }

                        .feature-icon {
                            width: 24px;
                            height: 24px;
                            object-fit: contain;
                        }

                        .feature-title {
                            font-family: 'HKNova-Bold', sans-serif;
                            font-size: 16px;
                            font-weight: 700;
                            text-transform: uppercase;
                            color: $white;
                            line-height: 20px;

                            @media (max-width: $breakpoint-sm) {
                                text-align: center;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: $breakpoint-md) {
    #services-business-crypto {
        .content-container {
            padding-top: $margin-m;
            padding-bottom: 80px;
        }
    }
}
</style>
